<div
  class="checkin__slide__out__wrapper checkin__slide__out__wrapper--{{ slideOutType }}"
  [@slideOut]="{ value: animationState, params: { axis: getAxis() }}">
  <ng-content></ng-content>
</div>
<div
  class="checkin__slide__out__overlay checkin__slide__out__overlay--{{ slideOutType }}"
  (click)="close()"
  [@slideOutOverlay]="animationState">
</div>
